import {Component} from '@angular/core';

@Component({
    selector: 'tfl-incoming-transfer-icon',
    template: require('./incoming.html')
})
export class IncomingTransferIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/incoming/incoming.transfer.icon.ts